import axios from 'axios'

export const urls = {
  memberLogin: '/api/auth/member/login',
  me: '/api/users/me',
  logout: '/api/auth/logout',
  autoLogIn: '/api/auth/member/auto-login',
}

export const memberLogin = (data, rememberMe) => {
  const loginData = {
    username: data.username,
    email: data.email,
    password: data.password,
    remember_me: rememberMe,
  }

  return axios.post(urls.memberLogin, loginData, {
    headers: {
      doNotAddUserTokenAuthorization: true,
    },
  })
}

export const authLogout = () => {
  return axios.post(urls.logout)
}

export const authMe = accessToken => {
  const loginData = {
    access_token: accessToken,
  }
  const data = axios.get(urls.me, loginData, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })

  return data
}
export const autoLogIn = (id, hash) => {
  return axios.get(`${urls.autoLogIn}/${id}/${hash}`)
}
